if (!customElements.get('mega-menu-sidebar')) {
  class MegaMenuSidebar extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.navItems = [...this.querySelectorAll('[data-mm-target]')];
      this.panels = [...this.querySelectorAll('.mm-sidebar__panel')];

      this.navItems.forEach((item, index) => {
        item.addEventListener('pointerenter', () => this.activate(item));
        item.addEventListener('click', () => this.activate(item));
        item.addEventListener('focus', () => this.activate(item));
        item.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    activate(item) {
      const targetId = item.getAttribute('data-mm-target');
      if (!targetId) return;

      this.navItems.forEach((navItem) => {
        const active = navItem === item;
        navItem.classList.toggle('is-active', active);
        navItem.setAttribute('aria-selected', String(active));
        navItem.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const active = panel.id === targetId;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    onKeydown(event, index) {
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();

      let nextIndex = index;
      if (event.key === 'ArrowDown') nextIndex = (index + 1) % this.navItems.length;
      if (event.key === 'ArrowUp') nextIndex = (index - 1 + this.navItems.length) % this.navItems.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.navItems.length - 1;

      this.activate(this.navItems[nextIndex]);
      this.navItems[nextIndex].focus();
    }
  }

  customElements.define('mega-menu-sidebar', MegaMenuSidebar);
}


